(function () {
    'use strict';

    angular
        .module('social')
        .config(socialRoute);

    socialRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function socialRoute($stateProvider) {
        $stateProvider
            .state('root.social', {
                abstract: true,
                url: '/social',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state('root.social.subscriptions', {
                url: '/subscriptions',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/social/subscriptions/subscriptions.html',
                        controller: 'SubscriptionController',
                        controllerAs: 'subscriptionController'
                    }
                },
                resolve: {
                    subscriptions: function (SocialService, $stateParams) {
                        return SocialService.getAllSubscriptions().then(function (response) {
                            return response.data;
                        });
                    }
                }
            })
    }
})();